import { useParams, useNavigate } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import NewCheckoutBuilderForm from "../../components/form/checkout-builder/NewCheckoutBuilderForm";

export default function NewCheckoutBuilder() {
    const { productId } = useParams<{ productId: string }>();
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/products/edit/${productId}?tab=checkout`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Novo Checkout"
                description="Criar novo checkout para o produto"
            />
            <PageBreadcrumb
                pageTitle="Novo Checkout"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <NewCheckoutBuilderForm
                    productId={productId}
                    onSuccess={() => {
                        // Redirecionar para a página de edição do produto na aba de checkouts
                        navigate(`/products/edit/${productId}?tab=checkout`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao criar checkout:", error);
                    }}
                />
            </div>
        </>
    );
}